import { useQuery } from '@tanstack/react-query';
import { getMyOrganizations } from '@/modules/profile/services/accounts.service';
import type { GetOrganizationsResponse } from '../types/multi-orgs.types';

export const useGetMultiOrgs = (options?: { enabled?: boolean }) => {
  return useQuery<GetOrganizationsResponse>({
    queryKey: ['getMultiOrgs'],
    queryFn: getMyOrganizations,
    enabled: options?.enabled ?? true,
    retry: (failureCount, error: unknown) => {
      const status = error instanceof Error ? (error as { status?: number }).status : undefined;
      if (status === 401 || status === 403) {
        return false;
      }
      return failureCount < 2;
    },
    throwOnError: false,
  });
};
